var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal-backdrop in" }),
    _c("div", { staticClass: "modal bounceIn in" }, [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "a",
              {
                staticClass: "close text-danger",
                attrs: { href: "javascript: void(0)" },
                on: {
                  click: function($event) {
                    return _vm.onClose()
                  }
                }
              },
              [_vm._v("×")]
            )
          ]),
          _c(
            "div",
            {
              staticClass: "modal-body",
              class: { "text-center": _vm.textCenter }
            },
            [
              _c("span", {
                class: { "text-danger": _vm.textRed },
                domProps: { innerHTML: _vm._s(_vm.content) }
              }),
              _vm.isShowQR
                ? _c("recharge-info", {
                    staticClass: "recharge-info-scaled",
                    attrs: { showGuide: 0, money: _vm.moneyRecharge }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "modal-footer" }, [
            _vm.showCloseButton === true
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-default btn-sm btn-happy",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.onClose()
                      }
                    }
                  },
                  [_vm._v("Đóng")]
                )
              : _vm._e(),
            _vm.showOtherButton === true
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-other btn-sm btn-happy",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.onOtherAction()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.otherButtonText))]
                )
              : _vm._e(),
            _vm.showNextButton === true
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-danger btn-sm btn-happy",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.onAccept()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.nextButtonText))]
                )
              : _vm._e()
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }